import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useCustomTheme} from 'context/customTheme';
import {useReservation} from 'context/reservation/useReservation';
import {useReservationSettings} from 'hooks';
import {ShareButton} from 'components/ShareButton';
import Dropdown from 'components/common/Dropdown';
import {Container, GuestInformation, Lowercase, StyledIcon, Wrapper} from './styled';

type Props = {
  currentGuests: number;
  totalGuests: number;
  onEditClick: () => void;
};
function HeaderGuestInformation({currentGuests, totalGuests, onEditClick}: Props) {
  const {t} = useTranslation();
  const {finalTheme} = useCustomTheme();
  const {checkCanEditReservationDetails} = useReservationSettings();
  const {allowEditingGuestNumber} = useReservation();
  const canEditReservationDetails = checkCanEditReservationDetails();
  const canEditGuestNumber = canEditReservationDetails && allowEditingGuestNumber;

  const {colors} = finalTheme;
  const dropdownOptions = useMemo(() => {
    return [
      {
        id: 1,
        label: t('edit_number_of_guests'),
        onClick: onEditClick,
      },
    ];
  }, [t, onEditClick]);

  return (
    <Wrapper className="guest-register-view__title-wrapper">
      <Container className="guest-register-view__title-container">
        <Dropdown
          position="bottom left"
          options={dropdownOptions}
          disabled={!canEditGuestNumber}
          trigger={
            <GuestInformation>
              {currentGuests} {t('of')} {totalGuests} <Lowercase>{t('guests')}</Lowercase>
              {canEditGuestNumber && (
                <StyledIcon
                  name="arrow"
                  title="edit"
                  size={12}
                  color={colors.buttons.textButton}
                />
              )}
            </GuestInformation>
          }
        />

        <ShareButton />
      </Container>
    </Wrapper>
  );
}

export {HeaderGuestInformation};
